module.exports = __webpack_public_path__ + "static/mspiVsEsg-33e77baf5a982fa4f36789a20aa0f284.jpg";